import _asyncToGenerator from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import HTTPMethod from 'http-method-enum';
import { API_MY_REP } from '@poplar/constants/routes';
import { QUERY_PARAM_LOCALE } from '@yoweb/utils/constants/queryParams';
import { safeFetch } from './utils';

var getRep = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(locale) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", safeFetch("".concat(API_MY_REP, "?").concat(QUERY_PARAM_LOCALE, "=").concat(locale), {
              method: HTTPMethod.GET
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getRep(_x) {
    return _ref.apply(this, arguments);
  };
}();

export { getRep };